// src/pages/ComingSoonPage.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Jika Anda ingin ada link kembali ke Home
import { RocketLaunchIcon, ClockIcon, EnvelopeIcon } from '@heroicons/react/24/outline';

// Komponen untuk Countdown Timer (Opsional)
const CountdownTimer = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    // Membersihkan timer jika komponen unmount atau targetDate berubah
    return () => clearTimeout(timer);
  }); // Tidak ada array dependensi agar selalu update setiap detik

  const timerComponents = [];
  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval] && timeLeft[interval] !== 0) { // Jangan tampilkan jika undefined/null
      return;
    }
    timerComponents.push(
      <div key={interval} className="flex flex-col items-center justify-center bg-slate-700/50 p-3 sm:p-4 rounded-lg shadow-md min-w-[60px] sm:min-w-[70px]">
        <span className="text-2xl sm:text-3xl font-bold text-orange-400">{timeLeft[interval]}</span>
        <span className="text-xs uppercase text-slate-400">{interval}</span>
      </div>
    );
  });

  return timerComponents.length ? (
    <div className="flex justify-center space-x-2 sm:space-x-4 my-6 sm:my-8">
      {timerComponents}
    </div>
  ) : (
    <p className="text-lg text-emerald-400 my-6 sm:my-8">We're launching very soon!</p>
  );
};


const ComingSoonPage = () => {
  // Atur tanggal target peluncuran Anda di sini
  // Format: YYYY-MM-DDTHH:mm:ss (misalnya, 1 Juni 2025 jam 9 pagi)

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-slate-900 via-black to-purple-950/30 text-slate-100 p-6 animate-fadeIn">
      <div className="text-center max-w-2xl w-full bg-slate-800/60 backdrop-blur-xl border border-slate-700/50 rounded-2xl shadow-2xl p-8 sm:p-10 md:p-12">
        
        <RocketLaunchIcon className="h-20 w-20 sm:h-24 sm:w-24 text-orange-500 mx-auto mb-6 animate-bounce" />

        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 via-red-500 to-pink-500 mb-4">
          Something Awesome is Coming Soon!
        </h1>
        
        <p className="text-md sm:text-lg text-slate-300 mb-6 sm:mb-8 leading-relaxed">
          We're working hard to bring you an amazing new experience. Our AI Agent Marketplace
          will launch soon, stay tuned for groundbreaking features!
        </p>

        <p className="text-xs text-slate-500 mt-8">
          &copy; {new Date().getFullYear()} AI Agent Marketplace. All rights reserved.
        </p>
        
        {/* Link kembali ke Home jika diperlukan */}
        <div className="mt-8">
          <Link to="/" className="text-orange-400 hover:text-orange-300 hover:underline text-sm font-medium">
            &larr; Back to Home
          </Link>
        </div>
       
      </div>
    </div>
  );
};

export default ComingSoonPage;